<template>
    <div class="container">
        <p class="page_title">회원 현황</p>
        <section class="section sec1">
            <div class="sec_titbox h_80">
                <div class="leftbox">
                    <p class="tit">
                        전체 회원 <span class="color">{{ userList.length }}</span>명 /
                        유료회원 비율 <span class="color">{{ payRatio }}%</span>
                    </p>
                </div>
                <div class="rightbox big_gap">
                    <div class="planstate_box">
                        <a href="page03_02_02.html" class="item">
                            <img :src="`${$STATIC_URL}/admin/img/plan_p.png`" alt="" class="icon">
                            <span class="txt">
                                {{ premiumRatio }}% (<span class="point">{{ premiumCount }}</span>)
                            </span>
                        </a>
                        <a href="page03_02_01.html" class="item">
                            <img :src="`${$STATIC_URL}/admin/img/plan_b.png`" alt="" class="icon">
                            <span class="txt">
                                {{ basicRatio }}% (<span class="point">{{ basicCount }}</span>)
                            </span>
                        </a>
                        <a href="#none" class="item">
                            <img :src="`${$STATIC_URL}/admin/img/plan_f.png`" alt="" class="icon">
                            <span class="txt">
                                {{ freeRatio }}% (<span class="point">{{ freeCount }}</span>)
                            </span>
                        </a>
                    </div>
                    <button type="button" class="btn ver2 reset_btn">
                        <span class="icon"></span>
                        <span class="txt">초기화</span>
                    </button>
                </div>
            </div>
        </section>

        <section class="section sec2">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">회원수 <span class="color">{{ totalCount }}</span></p>
                </div>
                <div class="rightbox">
                    <div class="filter_box">
                        <button type="button" id="chart2_daybtn" class="filter_btn day"
                            :class="{ 'on': chartType == 0 }" @click="changeChartMonth(selectedMonth)">일별</button>
                        <button type="button" id="chart2_monthbtn" class="filter_btn month"
                            :class="{ 'on': chartType == 1 }" @click="changeChartYear(selectedYear)">월별</button>
                    </div>
                </div>
            </div>
            <div class="chart_box">
                <div class="chart_top">
                    <div class="select_box" v-if="chartType == 0">
                        <select class="select" v-model="selectedMonth" @change="changeMonth(selectedMonth)">
                            <option value="1">1월</option>
                            <option value="2">2월</option>
                            <option value="3">3월</option>
                            <option value="4">4월</option>
                            <option value="5">5월</option>
                            <option value="6">6월</option>
                            <option value="7">7월</option>
                            <option value="8">8월</option>
                            <option value="9">9월</option>
                            <option value="10">10월</option>
                            <option value="11">11월</option>
                            <option value="12">12월</option>
                            <option value="13">기간</option>
                        </select>
                    </div>
                    <div class="select_box" v-if="chartType == 1">
                        <select class="select" v-model="selectedYear" @change="changeChartYearData(selectedYear)">
                            <option value="2025">2025년</option>
                            <option value="2026">2026년</option>
                            <option value="2027">2027년</option>
                            <option value="2028">2028년</option>
                            <option value="2029">2029년</option>
                        </select>
                    </div>
                    <div class="input_box date" v-if="isDatePicker">
                        <VueDatePicker range :model-value="rangeDate" @update:model-value="searchFilter"
                            :clearable="false" :teleport="true" />
                    </div>
                </div>
                <div class="chart" v-if="chartType == 0">
                    <Bar :options="chartOptions" :data="chartData" />
                </div>
                <div class="chart" v-if="chartType == 1">
                    <Bar :options="chartOptions" :data="chartData2" />
                </div>
                <div class="chart_labels">
                    <div class="label">
                        <span class="box_color color1"></span>
                        <span class="label_txt">Premium</span>
                    </div>
                    <div class="label">
                        <span class="box_color color2"></span>
                        <span class="label_txt">Basic</span>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script setup>
import { onMounted, ref, computed } from 'vue';
import { getUserQuotes, getUserQuotesPeriod, getUserQuotesMonth } from '@/api';
import { Bar } from 'vue-chartjs'
import { createGradient } from '@/utils';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement)

const userList = ref([]);
const premiumCount = ref(0);
const basicCount = ref(0);
const freeCount = ref(0);
const chart1Label = ref([]);
const chart1FirstData = ref([])
const chart1SecondData = ref([])
const chart2Label = ref([])
const chart2FirstData = ref([])
const chart2SecondData = ref([])
const totalCount = ref(0);
const rangeDate = ref([])
const selectedYear = ref(new Date().getFullYear());

function changeChartMonth() {
    chartType.value = 0

}

function changeChartYear() {
    chartType.value = 1
}

onMounted(async () => {
    const res = await getUserQuotes();
    userList.value = [...res.data.userList];
    userList.value.forEach(user => {
        if (user.type === 1) premiumCount.value++;
        else if (user.type === 0) basicCount.value++;
        else if (user.type === null) freeCount.value++;
    });
    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    changeChart1Days(`${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`, `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`);
    changeChartYearData(selectedYear.value)
});

async function changeChartYearData(year) {
    const res = await getUserQuotesMonth(year);
    chart2Label.value = res.data.typeOne.map(item => item.date);
    chart2FirstData.value = res.data.typeOne.map(item => item.count);
    chart2SecondData.value = res.data.typeZero.map(item => item.count);
}

async function changeChart1Days(start, end) {
    const res2 = await getUserQuotesPeriod(start, end);
    totalCount.value = 0
    chart1Label.value = res2.data.typeZero.map(item => {
        const date = new Date(item.pay_date);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${month}-${day}`;
    });
    chart1FirstData.value = res2.data.typeOne.map(item => {
        totalCount.value += item.count;
        return item.count;
    });
    chart1SecondData.value = res2.data.typeZero.map(item => {
        totalCount.value += item.count;
        return item.count;
    });
}

async function changeMonth(value) {
    if (value != 13) {
        const startDate = new Date(new Date().getFullYear(), value - 1, 1);
        const endDate = new Date(new Date().getFullYear(), value, 0);
        changeChart1Days(`${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`, `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`);
    }
}



const searchFilter = (modelData) => {
    rangeDate.value = modelData
    const [start, end] = modelData;
    const startDate = `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')}`;
    const endDate = `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`;
    changeChart1Days(startDate, endDate);
}

// 0: 월 통계, 1: 월별 통계
const chartType = ref(0)

const chartData = computed(() => {
    return {
        labels: chart1Label.value,
        datasets: [{
            label: 'Premium',
            data: chart1FirstData.value,
            backgroundColor: function (context) {
                return createGradient(context, '#9750f8', '#3e1ad6');
            },
            borderRadius: 8,
            barThickness: 24,
        },
        {
            label: 'Basic',
            data: chart1SecondData.value,
            backgroundColor: function (context) {
                return createGradient(context, '#3DB3FF', '#0060bd');
            },
            borderRadius: 8,
            barThickness: 24,
        }
        ]
    };
});

const chartData2 = computed(() => {
    return {
        labels: chart2Label.value,
        datasets: [{
            label: 'Premium',
            data: chart2FirstData.value,
            backgroundColor: function (context) {
                return createGradient(context, '#9750f8', '#3e1ad6');
            },
            borderRadius: 8,
            barThickness: 24,
        },
        {
            label: 'Basic',
            data: chart2SecondData.value,
            backgroundColor: function (context) {
                return createGradient(context, '#3DB3FF', '#0060bd');
            },
            borderRadius: 8,
            barThickness: 24,
        }
        ]
    };
})


const chartOptions = ref({
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: true,
        }
    },
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: {
            top: 0,
            left: -18,
            right: 0,
            bottom: 0,
        }
    },
    scales: {
        x: {
            offset: true,
            ticks: {
                padding: 12,
                font: {
                    family: 'Pretendard',
                    weight: '400',
                    size: 13,
                    color: '#40395d',
                },
            },
            grid: {
                display: false,
            },
        },
        y: {
            beginAtZero: false,
            suggestedMin: 1,
            ticks: {
                stepSize: 1,
                padding: 18,
                font: {
                    family: 'Pretendard',
                    weight: '400',
                    size: 13,
                    color: '#383b40',
                },
            },
            border: {
                display: false,
            },
        },
    },
})

const selectedMonth = ref(new Date().getMonth() + 1);
const payRatio = computed(() => {
    return ((basicCount.value + premiumCount.value) / userList.value.length * 100).toFixed(0);
});

const premiumRatio = computed(() => {
    return (premiumCount.value / userList.value.length * 100).toFixed(0);
});

const basicRatio = computed(() => {
    return (basicCount.value / userList.value.length * 100).toFixed(0);
});

const freeRatio = computed(() => {
    return (freeCount.value / userList.value.length * 100).toFixed(0);
});

const isDatePicker = computed(() => {
    if (selectedMonth.value == 13) {
        return true;
    } else {
        return false;
    }
})


</script>
<style scoped></style>
